

	import { Component, Prop, Watch } from 'vue-property-decorator';
	import { PropType } from 'vue';
	import { BaseView } from '@shared/views/BaseView';
	import { Deck, DeckVariation } from '@shared/models';

	@Component({})
	export default class DeckVariationList extends BaseView { 

		@Prop({ type: Object as PropType<Deck> })
		public model: Deck;

		@Prop({ default: () => [] })
		public variations: DeckVariation[];

		public loading: boolean = false;
		public showLength: boolean = false;
		public showWidth: boolean = false;
		public showNose: boolean = false;
		public showTail: boolean = false;
		public showWheelBase: boolean = false;
		public showInfo: boolean = true;
		public empty: boolean = true;

		@Watch('variations', { immediate: true, deep: true })
		public buildList() {
			this.empty = true;
			for (const item of this.variations) {
				if (item.noseLength) { this.showNose = true; this.empty = false; }
				if (item.tailLength) { this.showTail = true; this.empty = false; }
				if (item.wheelBase) { this.showWheelBase = true; this.empty = false; }
				if (item.length) { this.showLength = true; this.empty = false; }
				if (item.width) { this.showWidth = true; this.empty = false; }
			}
		}

	}

